"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarNote = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CalendarNote = function CalendarNote() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.947 2.526h1.264a2.526 2.526 0 012.526 2.527v16.42A2.526 2.526 0 0121.21 24H3.526A2.526 2.526 0 011 21.474V5.053a2.526 2.526 0 012.526-2.527H4.79V.632c0-.35.283-.632.632-.632h1.263c.349 0 .632.283.632.632v1.894H17.42V.632c0-.35.283-.632.632-.632h1.263c.349 0 .631.283.631.632v1.894zM3.527 21.474H21.21V7.579H3.526v13.895zm3.157-3.79H13a.632.632 0 00.632-.631v-1.264a.632.632 0 00-.632-.631H6.684a.632.632 0 00-.631.632v1.263c0 .348.282.631.631.631zm11.369-5.052H6.684A.632.632 0 016.053 12v-1.263c0-.349.282-.632.631-.632h11.369c.348 0 .631.283.631.632V12a.632.632 0 01-.631.632z",
    clipRule: "evenodd"
  });
};

exports.CalendarNote = CalendarNote;